import React from "react";
import { CgCalendarToday } from "react-icons/cg";

import * as S from "./styles";

export default function DatePickerCustomInput(inputProps) {
  return (
    <>
      <S.Input {...inputProps} mask="99/99/9999" />
      <S.IconWrapper>
        <CgCalendarToday
          onClick={inputProps.onClick}
          size={25}
          color="#00a2e0"
        />
      </S.IconWrapper>
    </>
  );
}
